<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionBillingMySalesDropDownFilters"
  >
    <section
      v-if="showLoadingState < 4"
      key="loadingState"
      class="m-dropdown-section"
    >
      <ul class="m-dropdown-list">
        <li>
          <a
            href="#"
            @click.prevent=""
          >
            <AtomLoadingSecondary/>
          </a>
        </li>
      </ul>
    </section>
    <form
      v-else
      key="billingMySalesDropDownFilters"
      autocomplete="off"
      name="MySalesDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.tiposDeVenta.label') }}
            </a>
            <div class="m-dropdown-sublist display-flex-row">
              <div
                v-for="(typeSale, index) in $filters.parameters.typesOfSales"
                :key="index"
              >
                <AtomRadioButtonPrimary
                  v-model.number="filter.type_sales"
                  :radio-button-primary="radioButtonPrimary.typeSales"
                  :text="typeSale.name"
                  :value="typeSale.id"
                  wrapperClass="a-input-side margin-top-xsmall margin-bottom-xsmall"
                />
              </div>
            </div>
          </li>
        </ul>
        <ul
          v-if="!filter.type_sales"
          class="m-dropdown-list"
        >
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.estado.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(estado, index) in estadosVentas"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.estado"
                    inputStyle="billing"
                    name="estado"
                    :text="estado.name"
                    :value="estado.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.pais.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.pais"
                :elements="paisesSelect"
                key-field="id_pais"
                name="pais"
                reference="pais"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
        <ul
          v-if="!filter.type_sales"
          class="m-dropdown-list"
        >
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.divisa.label') }}
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(divisa, index) in divisas"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.divisa"
                    inputStyle="billing"
                    name="moneda"
                    :text="divisa.nombre"
                    :value="divisa.id_divisa"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul
          v-if="!filter.type_sales"
          class="m-dropdown-list"
        >
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.medioPago.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(pasarela, index) in pasarelasPago"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.pasarela_pago"
                    inputStyle="billing"
                    name="medio"
                    :text="pasarela.nombre"
                    :value="pasarela.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
             {{ $t('mEditionBillingMySalesDropDownFilters.input.email.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.buscar"
                class="a-input-primary"
                name="email"
                :placeholder="$t('mEditionBillingMySalesDropDownFilters.input.email.placeholder')"
                type="text"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.fechaDesde.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionBillingMySalesDropDownFilters.input.fechaDesde.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.fechaHasta.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionBillingMySalesDropDownFilters.input.fechaHasta.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.productos.label') }}
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(producto, index) in productos"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.producto"
                    inputStyle="billing"
                    name="productos"
                    :text="producto.nombre"
                    :value="producto.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesDropDownFilters.input.descuento.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <input
                v-model="filter.cupon"
                class="a-input-primary"
                name="descuento"
                :placeholder="$t('mEditionBillingMySalesDropDownFilters.input.descuento.placeholder')"
                type="text"
              >
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionBillingMySalesDropDownFilters.buttonSecondary.restartText') }}
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionBillingMySalesDropDownFilters.buttonPrimary') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMySalesDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      disabledDates: {
        to: ''
      },

      divisas: [],
      estadosVentas: [],

      filter: {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: [],
        type_sales: ''
      },

      pasarelasPago: [],
      paises: [],
      productos: [],
      radioButtonPrimary: {
        typeSales: {
          labelClass: 'a-radiobutton-billing-primary font-size-small',
          name: 'type-sale'
        }
      },
      showLoadingState: 0
    }
  },

  computed: {
    paisesSelect () {
      let paises = [...this.paises]
      paises.unshift({
        id_pais: '',
        nombre: this.$t('mEditionBillingMySalesDropDownFilters.input.pais.firstOption')
      })
      return paises
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    'filter.type_sales' () {
      if (this.filter.type_sales) {
        this.filter.estado = []
        this.filter.divisa = []
        this.filter.pasarela_pago = []
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.buscar = this.filterSeted.buscar
        this.filter.cupon = this.filterSeted.cupon
        this.filter.divisa = [...this.filterSeted.divisa]
        this.filter.estado = [...this.filterSeted.estado]
        this.filter.type_sales = this.filterSeted.type_sales
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.pais = this.filterSeted.pais
        this.filter.pasarela_pago = [...this.filterSeted.pasarela_pago]
        this.filter.producto = [...this.filterSeted.producto]

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  created () {
    this.estadosVentas = [...this.$filters.parameters.salesStates].filter(s => s.id !== 9)
    this.estadosVentas.shift()
    this.readDivisas()
    this.readPasarelasPagoActivas()
    this.readParametroPaises()
    this.readProductos()
  },

  methods: {
    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readPasarelasPagoActivas () {
      this.$services.read('pasarela', 'readPasarelas')
        .then(response => {
          this.pasarelasPago = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readProductos () {
      this.$services.read('producto', 'readProductos', {}, [this.$store.getters.getAcademyData.id], { limite: 1000 })
        .then(response => {
          this.productos = response.data.productos
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionBillingMySalesDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter)
    }
  }
}
</script>
